import { render } from "./AlurVerifikasi.vue?vue&type=template&id=6fc0cada&scoped=true"
import script from "./AlurVerifikasi.vue?vue&type=script&lang=js"
export * from "./AlurVerifikasi.vue?vue&type=script&lang=js"

import "./AlurVerifikasi.vue?vue&type=style&index=0&id=6fc0cada&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc0cada"]])

export default __exports__